import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';

const Chatbox = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([
    {
      id: Date.now(),
      type: 'bot',
      text: 'नमस्ते! R.P. Educational Welfare Trust में आपका स्वागत है। हम आपकी कैसे मदद कर सकते हैं?',
    },
  ]);

  const handleSend = () => {
    if (message.trim()) {
      setMessages([...messages, { id: Date.now(), type: 'user', text: message }]);
      setMessage('');
      
      // Auto-reply
      setTimeout(() => {
        setMessages((prev) => [
          ...prev,
          {
            id: Date.now() + 1,
            type: 'bot',
            text: 'धन्यवाद! हमारी टीम जल्द ही आपसे संपर्क करेगी। अधिक जानकारी के लिए कृपया हमें +91 9801133975 पर कॉल करें।',
          },
        ]);
      }, 1000);
    }
  };

  return (
    <div className="chatbox-wrapper">
      {/* Chat Toggle Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="chatbox-toggle"
          aria-label="Open chat"
        >
          <MessageCircle size={28} />
        </button>
      )}

      {/* Chatbox */}
      {isOpen && (
        <div className="chatbox">
          <div className="chatbox-header">
            <div className="flex items-center">
              <MessageCircle className="mr-2" size={24} />
              <div>
                <h3 className="font-semibold">R.P. Educational Trust</h3>
                <p className="text-xs">We're here to help</p>
              </div>
            </div>
            <button onClick={() => setIsOpen(false)} className="hover:bg-purple-600 p-1 rounded">
              <X size={20} />
            </button>
          </div>
          <div className="chatbox-body">
            {messages.map((msg) => (
              <div
                key={msg.id}
                className={`mb-3 ${msg.type === 'user' ? 'text-right' : 'text-left'}`}
              >
                <div
                  className={`inline-block px-4 py-2 rounded-lg ${
                    msg.type === 'user'
                      ? 'bg-purple-700 text-white'
                      : 'bg-gray-200 text-gray-800'
                  }`}
                >
                  {msg.text}
                </div>
              </div>
            ))}
          </div>
          <div className="chatbox-footer">
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSend()}
              placeholder="Type a message..."
              className="flex-1 px-4 py-2 border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <button
              onClick={handleSend}
              className="bg-purple-700 text-white px-4 py-2 rounded-r-lg hover:bg-purple-800 transition-colors"
            >
              <Send size={20} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbox;
